import { Injectable } from '@angular/core';
import { Events, LoadingController, Platform } from 'ionic-angular';
import { Globals } from '../../globals';
import { TranslateService } from '@ngx-translate/core';
import { CustomersServices } from '../customers/services';
import { OrdersCoServices } from '../orders/services';
import { TPVServices } from '../tpv/services';
import { InvoicesServices } from '../invoices/services';
import { TakeawayServices } from '../takeaway/services';
import { FormGroup } from '@angular/forms';

@Injectable()
export class SearchServices {

  customer_search: any;
  customer_data: any;
  selectedPersonId: any = '';
  show_list: any;
  customers: any;
  og: any;
  form: FormGroup;
  customer_info: any = {};

  constructor(public events: Events,
    public loadingCtrl: LoadingController,
    public platform: Platform,
    public translate: TranslateService,
    public globals: Globals,
    public customersServices: CustomersServices,
    public ordersCoServices: OrdersCoServices,
    public tpvServices: TPVServices,
    public invoicesService: InvoicesServices,
    public takeawayServices: TakeawayServices,) {

    this.passObservableToArray();

  }

  async passObservableToArray() {
    //Obtenemos el array de clientes para poder trabajar con el
    this.customersServices.getListCustomers(this.globals.restaurant_uid);
    await this.customersServices.customers.subscribe(list => {
      this.customers = list;
    });
  }

  async searchCustomer() {
    if (this.customer_data != undefined) {
      //Buscamos en el array de clientes si hay algun elemento que coincida con el input

      //Añadimos todos los nombres de clientes que contengan el input
      this.customer_search = this.customers.filter(item => item.name.toLowerCase().indexOf(this.customer_data.toLowerCase()) !== -1);

      //Añadimos todos los emails de clientes que contengan el input
      this.customer_search = this.customer_search.concat(this.customers.filter(item => item.email.toLowerCase().indexOf(this.customer_data.toLowerCase()) !== -1));

      //Añadimos todos los telefonos de clientes que contengan el input
      this.customer_search = this.customer_search.concat(this.customers.filter(item => item.phone.toString().toLowerCase().indexOf(this.customer_data.toLowerCase()) !== -1));

      //Eliminamos los elementos duplicados mirando el email del cliente
      this.customer_search = this.removeDuplicates(this.customer_search, 'UID');

      //Si el input tiene 2 o más caracteres mostramos la lista
      if (this.customer_data.length >= 2) {
        this.show_list = true;
      } else {
        this.show_list = false;
      }
    }
  }

  removeDuplicates(array, key) {
    let lookup = {};
    array.forEach(element => {
      lookup[element[key]] = element
    });
    return Object.keys(lookup).map(key => lookup[key]);
  };

  selectCustomer(customer) {
    this.selectedPersonId = customer.UID;
    this.customer_data = customer.name;
    this.customer_info = customer;
    this.show_list = false;

    if (this.og === 'reservation') {
      this.form.get('UID_CLIENT').setValue(customer.UID);
      this.form.get('name').setValue(customer.name);
      this.form.get('email').setValue(customer.email);
      this.form.get('phone').setValue(customer.phone);
    } else if (this.og === 'orders') {
      this.ordersCoServices.selectedPersonId = this.selectedPersonId;
    } else if (this.og === 'tpv') {
      this.tpvServices.selectedPersonId = this.selectedPersonId;
    } else if (this.og === 'invoices') {
      this.invoicesService.customer_selected = customer;
    } else {
      this.takeawayServices.selectedPersonId = this.selectedPersonId;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/services/searchs.ts